export const SEARCH_UPDATE = "catalog::search::update";
export const SEARCH_REQUEST = "catalog::search::request";
export const SEARCH_COMPLETE = "catalog::search::complete";
export const FILTER_UPDATE = "catalog::filter::update";
export const FILTERS_RESET = "catalog::filters::reset";
export const TYPE_UPDATE = "catalog::type::update";
export const PAGE_UPDATE = "catalog::page::update";
